export default class TimedCompanionExtension {
    static waitForMessageOrGiveUp = async (promise: Promise<any>, timeoutInMillis: number) => {
        const promiseTimeout = new Promise((_, reject) => (
            setTimeout(() => reject({ errors: ['EXTENSION_TIMED_OUT'] }), timeoutInMillis)
        ));
        return await Promise.race([promise, promiseTimeout]);
    }
} 